import V3Adapter from './v3';

export default class SignInFieldPageAdapter extends V3Adapter {}
